export default (value, step) => {
  const remainder = value % step

  if (!value) {
    return step
  }

  if (!remainder) {
    return value + step
  }

  return Math.ceil(value / step) * step
}
